import { Select } from "@mui/material"
import { styled } from "@mui/material/styles"

export const SbSelect = styled(Select)(({theme}) => ({
	"&": {
		color: "white",
		labelColor: "white",
		backgroundColor: theme.palette.secondary.main,
		fontSize: "0.8em",
	},
	"& .MuiSelect-select": {
		paddingTop: "3px",
		paddingBottom: "3px",
		margin: "0 8px",
	},
	"& .MuiOutlinedInput-notchedOutline": {
		border: "none",
	},
	"& .MuiSelect-icon": {
		color: "white",
	},
}))
